import { makeStyles } from '@material-ui/core';
import { Colors } from '../../constants';

export default makeStyles((theme) => ({
  aiWidgetContainer: {
    position: 'absolute',
    right: 10,
    bottom: 10,
  },
  root: {
    fontFamily: 'Sora, sans-serif',
    pointerEvents: 'none',
  },
  paper: ({ widgetPosition }: { widgetPosition: any }) => ({
    transition: 'all 0.3s ease',
    position: 'absolute',
    bottom: 36,
    left: Number(widgetPosition?.left ?? 580) - 580,
    maxWidth: 550,
    height: 555,
    borderRadius: 11,
    pointerEvents: 'auto',
    '&.expanded': {
      left: Number(widgetPosition?.left ?? 950) - 950,
      maxWidth: 920,
      height: 900,
    },
  }),
  dialogTitle: {
    background: `linear-gradient(45deg,${Colors.primary} 30%,${Colors.primaryGradient} 70%,${Colors.secondary} 90%)`,
    padding: theme.spacing(0, 2.5),
  },
  dialogContent: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 17,
    flexDirection: 'column',
    padding: theme.spacing(1, 0, 0),
  },
  titleLeftContainer: {
    color: Colors.white,
    fontSize: 17,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      height: 20,
      marginRight: theme.spacing(0.5),
    }
  },
  newButton: {
    backgroundColor: Colors.white,
    borderRadius: 100,
    width: 68,
    height: 26,
    fontSize: 12,
    fontWeight: 600,
    color: Colors.primary,
    lineHeight: 1,
    marginLeft: theme.spacing(2),

    '& svg': {
      height: 15,
      marginRight: theme.spacing(0.5),
    },

    '&:hover': {
      backgroundColor: Colors.white,
    },
  },
  closeButton: {
    marginRight: theme.spacing(-2),
    color: Colors.white,

    '& svg': {
      height: 24,
      width: 24,
    }
  },
  separator: {
    height: 1,
    backgroundColor: Colors.gray,
    border: 'none',
    marginTop: 0,
  },
  inputField: {
    display: 'flex',
    flexGrow: 1,
    '& .ai-widget-MuiOutlinedInput-root': {
      border: 'none',
    },
    '& .ai-widget-MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '& input': {
      fontSize: 14,
      borderRadius: 40,
      backgroundColor: Colors.lightBlue,
      padding: theme.spacing(2, 1.5),
    },
  },
  dialogActions: {
    padding: theme.spacing(1, 2),
    justifyContent: 'flex-start',
    '& button': {
      backgroundColor: Colors.primary,
      color: Colors.white,
    },
    '& button:hover': {
      backgroundColor: Colors.primary,
    }
  },
  sendButton: {
    height: 40,
    width: 40,
    border: `1px solid ${Colors.lightGray}`,
    backgroundColor: Colors.primary,
    color: Colors.white,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: Colors.primary,
    },
    '& svg': {
      height: 15,
      width: 15,
    }
  },
  marginRight: {
    marginRight: theme.spacing(0.5),
  },
  importantInfo: {
    fontSize: 12,
    color: Colors.textGray,
    alignSelf: 'center',
    paddingBottom: theme.spacing(1),
  },
  welcomeTextContainerTM: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'end',
    alignSelf: 'baseline',
    paddingLeft: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  helloText: {
    fontFamily: 'Sora',
    fontSize: 21,
    fontWeight: 700,
    background: `linear-gradient(263.07deg, ${Colors.secondary} 0.27%, ${Colors.primaryGradient} 9.75%, ${Colors.primary} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    /* For Firefox */
    backgroundClip: 'text',
    color: 'transparent',
  },
  helpText: {
    fontSize: 21,
    fontWeight: 600,
    color: Colors.disabledText,
  },
  resizeButton: {
    marginRight: theme.spacing(-2),
    color: Colors.white,
    '& svg': {
      height: 20,
      width: 20,
    }
  },
  dummyPromptsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    alignItems: 'flex-start',
  },
  dummyPrompts: {
    width: 'fit-content',
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    backgroundColor: '#f6f8ff',
    borderRadius: '0 .7em .7em .7em',
    marginBottom: theme.spacing(1),
    fontFamily: 'Helvetica Neue,Segoe UI,Helvetica,Arial,sans-serif',
    fontSize: '14.5px',
  },
  promptHeader: {
    marginBottom: theme.spacing(1),
  },
}));
